export default {"src":"/_next/static/media/forced.939a22fc.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};